"use strict";

/**
 * @classdesc
 * Abstrakte Wrapperklasse für eine Punkt-Geometrie.
 *
 * @class
 * @abstract
 * @extends gc.gis.geom.GCGeometry
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} point gewrappte Punkt-Geometrie-Instanz
 */
gc.gis.geom.GCPoint = function(point)
{
    gc.gis.geom.GCGeometry.call(this, point);
};
gc.gis.geom.GCPoint.prototype = Object.create(gc.gis.geom.GCGeometry.prototype);


/**
 * Gibt die X-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} X-Koordinate
 * @public
 */
gc.gis.geom.GCPoint.prototype.getX = gc.gis.abstractMethod;

/**
 * Gibt die Y-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} Y-Koordinate
 * @public
 */
gc.gis.geom.GCPoint.prototype.getY = gc.gis.abstractMethod;

/**
 * Gibt die Z-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} Z-Koordinate
 * @public
 */
gc.gis.geom.GCPoint.prototype.getZ = gc.gis.abstractMethod;

/**
 * Setzt die Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @param {double} z Z-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.GCPoint.prototype.set = gc.gis.abstractMethod;

/**
 * Setzt die XY-Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.GCPoint.prototype.setXY = gc.gis.abstractMethod;

/**
 * Setzt die XYZ-Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @param {double} z Z-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.GCPoint.prototype.setXYZ = gc.gis.abstractMethod;